import { atom } from "recoil";
import { policyTypeData } from "../types/PolicyTypeInterface";

export const addStatePolicyType = atom({
  key: "addStatePolicyType",
  default: false,
});
export const editStatePolicyType = atom({
  key: "editStatePolicyType",
  default: false,
});
export const rowEditPolicyType = atom<policyTypeData | undefined>({
  key: "rowEditPolicyType",
  default: undefined,
});

export const selectedRowsStatePolicyType = atom<policyTypeData[]>({
  key: "selectedRowsStatePolicyType",
  default: [],
});

export const filterText = atom({
  key: "filterText",
  default: "",
});

export const savingPolicyType = atom({
  key: "savingPolicyType",
  default: false,
});
